<template>
  <v-flex class="agent-password">
    <v-card-title class="card-title">
      Email
    </v-card-title>
    <v-card-text v-if="profile" class="email-info">
      <span>{{ profile.email }}</span>
    </v-card-text>
  </v-flex>
</template>
<script>
export default {
  props: {
    profile: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
<style lang="sass">
  .email-info
    padding: 0px 16px 16px !important
    text-align: left
</style>
